import React from 'react';
import PropTypes from 'prop-types';

import { Text, Paragraph } from 'components/core/Typography';
import { Stars } from 'components/review/Stars';

import { Image } from 'components/core/Image';
import { ClickToShowNumberButton } from 'components/contact/ClickToShowNumberButton';

import stuffTrucks from 'assets/images/landing/moving-trucks/stuff-trucks.svg';

import './BrandBanner.scss';

export default function BrandBanner({ getTollfreePhoneNumber }) {
	return (
		<div className="section-container brand-banner-container">
			<div className="brand-banner-content">
				<Paragraph className="title" size="large">
					Find your stuff a home.
				</Paragraph>
				<div className="banner-review-container">
					<Text size="large" last>17,365</Text>
					<Stars rating={5} outOf={5} size="medium" />
				</div>
				<Paragraph className="fact" weight="medium" color="black">
					Over half a million people have found a great deal on moving and storage using SpareFoot.
				</Paragraph>
				<Paragraph
					size="large"
				>
					Need help with your move?
				</Paragraph>
				<Text className="click-to-show-number-text" color="black" weight="medium">
					Give us a call.
				</Text>
				<ClickToShowNumberButton
					outline
					fetchPhoneNumber={getTollfreePhoneNumber}
					showAsLink
					size="small"
				/>
			</div>
			<div className="brand-banner-image">
				<Image src={stuffTrucks} />
			</div>
		</div>
	);
}

BrandBanner.propTypes = {
	getTollfreePhoneNumber: PropTypes.func
};
